import { render, staticRenderFns } from "./List-2.vue?vue&type=template&id=49d88dae&scoped=true&"
import script from "./List-2.vue?vue&type=script&lang=js&"
export * from "./List-2.vue?vue&type=script&lang=js&"
import style0 from "./List-2.vue?vue&type=style&index=0&id=49d88dae&prod&lang=scss&"
import style1 from "./List-2.vue?vue&type=style&index=1&id=49d88dae&prod&lang=scss&scoped=true&"
import style2 from "./List-2.vue?vue&type=style&index=2&id=49d88dae&prod&scoped=true&lang=css&"
import style3 from "./List-2.vue?vue&type=style&index=3&id=49d88dae&prod&scoped=true&lang=css&"
import style4 from "./List-2.vue?vue&type=style&index=4&id=49d88dae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d88dae",
  null
  
)

export default component.exports